(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  document.querySelectorAll('[data-toc]').forEach((tocLinks) => {
    const body = document.querySelector('[data-article-body]');
    if (!body) return;
    const headings = body.querySelectorAll('h2');
    headings.forEach((h, i) => {
      if (!h.id) h.id = 'toc-section-' + (i + 1);
      const a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      a.className = 'art__toc-link';
      a.addEventListener('click', (e) => {
        e.preventDefault();
        h.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (window.history && history.pushState) {
          history.pushState(null, '', '#' + h.id);
        }
      });
      tocLinks.appendChild(a);
    });
  });

  document.querySelectorAll('[data-art-sidebar]').forEach((sidebar) => {
    const dataEl = sidebar.querySelector('[data-art-sidebar-variants]');
    if (!dataEl) return;
    let variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!variants || !variants.length) return;
    const pick = variants[Math.floor(Math.random() * variants.length)];
    sidebar.querySelectorAll('[data-art-sidebar-link]').forEach((el) => {
      if (pick.url) el.href = pick.url;
    });
    const img = sidebar.querySelector('[data-art-sidebar-img]');
    if (img && pick.image) {
      img.src = pick.image;
      img.srcset = '';
      if (pick.alt) img.alt = pick.alt;
    }
  });

  document.querySelectorAll('[data-copy-link]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const url = btn.dataset.url;
      if (!url || !navigator.clipboard || !navigator.clipboard.writeText) return;
      navigator.clipboard
        .writeText(url)
        .then(() => {
          const original = btn.textContent;
          btn.textContent = 'Copied!';
          setTimeout(() => {
            btn.textContent = original;
          }, 1800);
        })
        .catch(() => {});
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-promo"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bp]').forEach((bp) => {
    // One JSON tag per selected product; pool every in-stock variant from all of them.
    const variants = [];
    bp.querySelectorAll('[data-bp-variants]').forEach((dataEl) => {
      try {
        const list = JSON.parse(dataEl.textContent);
        if (Array.isArray(list)) variants.push(...list);
      } catch (e) {
        // Skip a product whose data didn't parse rather than dropping the whole pick.
      }
    });
    if (!variants.length) return;
    const pick = variants[Math.floor(Math.random() * variants.length)];
    bp.querySelectorAll('[data-bp-link]').forEach((el) => {
      if (pick.url) el.href = pick.url;
    });
    const titleEl = bp.querySelector('[data-bp-title]');
    if (titleEl && pick.title) {
      titleEl.textContent = pick.title;
    }
    const mediaLink = bp.querySelector('[data-bp-media-link]');
    if (mediaLink && pick.title) {
      mediaLink.setAttribute('aria-label', pick.title);
    }
    const img = bp.querySelector('[data-bp-img]');
    if (img && pick.image) {
      img.src = pick.image;
      img.srcset = '';
      if (pick.alt) img.alt = pick.alt;
    }
    const detailEl = bp.querySelector('[data-bp-detail]');
    if (detailEl) {
      detailEl.textContent = pick.detail || '';
      detailEl.hidden = !pick.detail;
    }
    const priceEl = bp.querySelector('[data-bp-price]');
    if (priceEl && pick.price) {
      priceEl.textContent = pick.price;
    }
    const wasEl = bp.querySelector('[data-bp-price-was]');
    if (wasEl) {
      wasEl.textContent = pick.comparePrice || '';
      wasEl.hidden = !pick.comparePrice;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    const sectionId = 'cart-drawer';

    const openDrawer = () => {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    };

    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    };

    const refreshDrawer = () => {
      const url = window.location.pathname + window.location.search;
      const sep = url.indexOf('?') === -1 ? '?' : '&';
      return fetch(url + sep + 'section_id=' + sectionId + '&_=' + Date.now(), { cache: 'no-store' })
        .then((res) => res.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-cart-drawer]');
          if (!fresh) return;
          const wasOpen = drawer.classList.contains('is-open');
          drawer.innerHTML = fresh.innerHTML;
          if (wasOpen) drawer.classList.add('is-open');
          updateCartCountBadge();
        })
        .catch(() => {});
    };

    const updateCartCountBadge = () => {
      fetch('/cart.js', { cache: 'no-store' })
        .then((res) => res.json())
        .then((cart) => {
          document.querySelectorAll('[data-cart-count-badge]').forEach((badge) => {
            badge.textContent = cart.item_count;
            badge.hidden = cart.item_count === 0;
          });
        })
        .catch(() => {});
    };

    // Open: header cart icon (and any element opting in with data-cart-drawer-open)
    document.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-cart-drawer-open]');
      if (opener) {
        e.preventDefault();
        openDrawer();
        return;
      }

      const closer = e.target.closest('[data-cart-drawer-close]');
      if (closer) {
        e.preventDefault();
        closeDrawer();
        return;
      }

      const decBtn = e.target.closest('[data-cart-qty-dec]');
      const incBtn = e.target.closest('[data-cart-qty-inc]');
      const removeBtn = e.target.closest('[data-cart-remove]');

      if (decBtn || incBtn || removeBtn) {
        const btn = decBtn || incBtn || removeBtn;
        const line = parseInt(btn.dataset.line, 10);
        let quantity = 0;
        if (removeBtn) {
          quantity = 0;
        } else {
          const valueEl = btn.parentElement.querySelector('.cdw__qty-value');
          const current = valueEl ? parseInt(valueEl.textContent, 10) || 0 : 0;
          quantity = incBtn ? current + 1 : Math.max(0, current - 1);
        }
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: quantity })
        })
          .then(() => refreshDrawer())
          .catch(() => {});
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeDrawer();
    });

    // Intercept any "add to cart" product form site-wide.
    document.addEventListener('submit', (e) => {
      const form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();

      const submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form)
      })
        .then((res) => res.json())
        .then((data) => {
          if (submitBtn) submitBtn.disabled = false;
          if (data.status) return; // Shopify error payload (e.g. sold out)
          refreshDrawer().then(openDrawer);
        })
        .catch(() => {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.querySelectorAll('[data-cart-page-qty]').forEach((wrap) => {
    const input = wrap.querySelector('.cpg__qty-input');
    const dec = wrap.querySelector('[data-qty-dec]');
    const inc = wrap.querySelector('[data-qty-inc]');
    if (!input) return;
    if (dec) {
      dec.addEventListener('click', () => {
        input.value = Math.max(0, (parseInt(input.value, 10) || 0) - 1);
      });
    }
    if (inc) {
      inc.addEventListener('click', () => {
        input.value = (parseInt(input.value, 10) || 0) + 1;
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.cf__form').forEach((form) => {
    const wrap = form.querySelector('[data-cf-wholesale]');
    const radios = form.querySelectorAll('[data-cf-topic]');
    const wholesaleFields = wrap ? wrap.querySelectorAll('[data-cf-wholesale-field]') : [];
    const formError = form.querySelector('[data-cf-form-error]');

    const syncWholesale = () => {
      let isWholesale = false;
      radios.forEach((r) => {
        if (r.checked && r.value.toLowerCase().indexOf('wholesale') !== -1) {
          isWholesale = true;
        }
      });
      if (wrap) wrap.hidden = !isWholesale;
      wholesaleFields.forEach((f) => {
        if (isWholesale) {
          f.setAttribute('required', '');
        } else {
          f.removeAttribute('required');
          clearFieldError(f);
        }
      });
    };

    const fieldWrap = (input) => input.closest('.cf__field');

    const clearFieldError = (input) => {
      const fw = fieldWrap(input);
      if (!fw) return;
      fw.classList.remove('is-invalid');
      const msg = fw.querySelector('.cf__field-error');
      if (msg) msg.remove();
    };

    const setFieldError = (input, message) => {
      const fw = fieldWrap(input);
      if (!fw) return;
      fw.classList.add('is-invalid');
      let msg = fw.querySelector('.cf__field-error');
      if (!msg) {
        msg = document.createElement('span');
        msg.className = 'cf__field-error';
        fw.appendChild(msg);
      }
      msg.textContent = message;
    };

    const validate = () => {
      let firstInvalid = null;
      form.querySelectorAll('[data-cf-required]').forEach((input) => {
        if (!input.hasAttribute('required')) {
          clearFieldError(input);
          return;
        }
        const value = (input.value || '').trim();
        let invalid = value === '';
        if (!invalid && input.hasAttribute('data-cf-email')) {
          invalid = value.indexOf('@') === -1 || value.indexOf('.') === -1;
        }
        if (invalid) {
          setFieldError(input, input.getAttribute('data-cf-required'));
          if (!firstInvalid) firstInvalid = input;
        } else {
          clearFieldError(input);
        }
      });
      return firstInvalid;
    };

    radios.forEach((r) => r.addEventListener('change', syncWholesale));
    syncWholesale();

    form.addEventListener('submit', (e) => {
      syncWholesale();
      const firstInvalid = validate();
      if (firstInvalid) {
        e.preventDefault();
        if (formError) formError.textContent = 'Please fill in the highlighted fields.';
        firstInvalid.focus();
      } else if (formError) {
        formError.textContent = '';
      }
    });

    form.querySelectorAll('[data-cf-required]').forEach((input) => {
      input.addEventListener('input', () => {
        clearFieldError(input);
        if (formError) formError.textContent = '';
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var el = document.querySelector('[data-bpd]');
    if (!el) return;
    var widthEl = el.querySelector('[data-bpd-width]');
    var labelEl = el.querySelector('[data-bpd-label]');

    // Matches the theme's actual breakpoints (see the @media rules
    // across sections/*.liquid): 480 / 600 / 750 / 900 / 1000.
    var tiers = [
      { max: 479, label: '<480 (mobile S)' },
      { max: 599, label: '480–599 (mobile L)' },
      { max: 749, label: '600–749 (tablet S)' },
      { max: 899, label: '750–899 (tablet)' },
      { max: 999, label: '900–999 (tablet L)' },
      { max: Infinity, label: '≥1000 (desktop)' }
    ];

    function render() {
      var w = window.innerWidth;
      widthEl.textContent = w + 'px';
      for (var i = 0; i < tiers.length; i++) {
        if (w <= tiers[i].max) {
          labelEl.textContent = tiers[i].label;
          break;
        }
      }
    }

    render();
    window.addEventListener('resize', render);
  })();

  document.querySelectorAll('[data-menu-drawer]').forEach((drawer) => {
    const openBtn = document.querySelector('[data-menu-open]');
    const open = () => {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
    };
    const close = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
    };
    if (openBtn) openBtn.addEventListener('click', open);
    drawer.querySelectorAll('[data-menu-close]').forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });
  });

  // Sticky header on mobile — hides on scroll down, reappears on scroll up.
  (function () {
    var header = document.querySelector('.header');
    if (!header) return;
    var mq = window.matchMedia('(max-width: 749px)');
    var naturalBottom = 0;
    var lastY = window.scrollY || window.pageYOffset || 0;
    var ticking = false;

    var measure = function () {
      if (header.classList.contains('header--stuck')) return;
      var rect = header.getBoundingClientRect();
      naturalBottom = rect.bottom + (window.scrollY || window.pageYOffset || 0);
    };

    var update = function () {
      ticking = false;
      var y = window.scrollY || window.pageYOffset || 0;

      if (!mq.matches) {
        header.classList.remove('header--stuck', 'header--visible');
        lastY = y;
        return;
      }

      // Near the top: normal in-flow header.
      if (y <= naturalBottom) {
        header.classList.remove('header--stuck', 'header--visible');
        lastY = y < 0 ? 0 : y;
        return;
      }

      // Past its original spot: it's fixed; show/hide by scroll direction.
      header.classList.add('header--stuck');
      var delta = y - lastY;
      if (delta > 4) {
        header.classList.remove('header--visible');
      } else if (delta < -4) {
        requestAnimationFrame(function () {
          header.classList.add('header--visible');
        });
      }
      lastY = y;
    };

    var onScroll = function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    };

    measure();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      measure();
      update();
    });
  })();

  // Highlight the Castor Oil / Roll-on nav link that matches the
  // currently selected product format tab. Both links point to the same
  // product page, so this is driven by the tab's own state (via a custom
  // event dispatched from the product section) rather than the URL.
  (function () {
    var links = document.querySelectorAll('.header__menu-link');
    if (!links.length) return;

    function normalize(text) {
      return (text || '').trim().toLowerCase();
    }

    function applyFormatHighlight(tabValue) {
      var isRollOn = normalize(tabValue).indexOf('roll') !== -1;
      links.forEach(function (link) {
        var text = normalize(link.textContent);
        var isRollOnLink = text.indexOf('roll') !== -1;
        var isCastorOilLink = text.indexOf('castor oil') !== -1;
        if (!isRollOnLink && !isCastorOilLink) return;
        var shouldHighlight = isRollOnLink ? isRollOn : !isRollOn;
        link.classList.toggle('header__menu-link--format-active', shouldHighlight);
      });
    }

    var activeTab = document.querySelector('[data-pdp-tab].is-active');
    if (activeTab) applyFormatHighlight(activeTab.dataset.pdpTab);

    document.addEventListener('pdp:tab-change', function (e) {
      applyFormatHighlight(e.detail && e.detail.tab);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-to-video"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('[data-htv-play]') : null;
    if (!button) return;

    var player = button.closest('[data-htv-player]');
    var template = player ? player.querySelector('template[data-htv-template]') : null;
    if (!player || !template || player.classList.contains('is-playing')) return;

    player.appendChild(template.content.cloneNode(true));
    player.classList.add('is-playing');

    var video = player.querySelector('video');
    if (video) {
      var started = video.play();
      if (started && started.catch) started.catch(function () {});
    } else {
      var frame = player.querySelector('iframe');
      if (frame) frame.focus();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pdp]').forEach((pdp) => {
    const idInput = pdp.querySelector('[data-pdp-id]');
    const totalEl = pdp.querySelector('[data-pdp-total]');
    const wasEl = pdp.querySelector('[data-pdp-total-was]');
    const selEl = pdp.querySelector('[data-pdp-sel]');
    const qtyInput = pdp.querySelector('[data-pdp-qty]');
    const atc = pdp.querySelector('[data-pdp-atc]');
    const atcLabel = pdp.querySelector('[data-pdp-atc-label]');
    const variants = Array.from(pdp.querySelectorAll('[data-pdp-variant]'));
    const activeLabel = atcLabel ? atcLabel.textContent : '';

    // Media slides (image / video / external video / model) are all
    // pre-rendered, keyed by media id, and toggled here rather than
    // having JS try to synthesise a video/model player on the fly.
    const showSlide = (mediaId) => {
      if (!mediaId) return false;
      const slides = Array.from(pdp.querySelectorAll('[data-pdp-slide]'));
      const target = slides.find((s) => s.dataset.mediaId === String(mediaId));
      if (!target || target.dataset.mediaUnavailable === 'true') return false;
      slides.forEach((slide) => {
        const match = slide === target;
        slide.hidden = !match;
        slide.classList.toggle('is-active', match);
        if (match) {
          slide.querySelectorAll('video').forEach((v) => {
            const p = v.play();
            if (p && p.catch) p.catch(() => {});
          });
        } else {
          slide.querySelectorAll('video').forEach((v) => v.pause());
        }
      });
      pdp.querySelectorAll('[data-pdp-thumb]').forEach((t) =>
        t.classList.toggle('is-active', t.dataset.mediaId === String(mediaId))
      );
      return true;
    };

    const filterThumbs = (tabValue) => {
      pdp.querySelectorAll('[data-pdp-thumb]').forEach((t) => {
        if (t.dataset.mediaSoldout === 'true') {
          t.hidden = true;
          return;
        }
        const mt = t.dataset.mediaTab;
        t.hidden = !!mt && !!tabValue && mt !== tabValue;
      });
    };

    const money = (cents) => {
      try {
        return '$' + (cents / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    };

    const qty = () => Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);

    const sync = (updateUrl) => {
      const checked = pdp.querySelector('.pdp__variant-radio:checked');
      if (!checked) return;
      const row = checked.closest('[data-pdp-variant]');
      const price = parseInt(row.dataset.price, 10);
      const compare = parseInt(row.dataset.compare, 10) || 0;
      if (idInput) idInput.value = checked.value;
      if (totalEl) totalEl.textContent = money(price * qty());
      if (wasEl) {
        if (compare > price) {
          wasEl.textContent = money(compare * qty());
          wasEl.hidden = false;
        } else {
          wasEl.hidden = true;
        }
      }
      if (selEl) selEl.textContent = row.dataset.detail || row.dataset.label;
      const soldOut = row.classList.contains('is-sold-out');
      if (atc) atc.disabled = soldOut;
      if (atcLabel) atcLabel.textContent = soldOut ? 'Sold out' : activeLabel;

      if (row.dataset.mediaId) {
        showSlide(row.dataset.mediaId);
      } else {
        const activeTab = pdp.querySelector('[data-pdp-tab].is-active');
        if (activeTab && activeTab.dataset.mediaId) showSlide(activeTab.dataset.mediaId);
      }

      if (updateUrl && window.history && history.replaceState) {
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', checked.value);
          history.replaceState({}, '', url);
        } catch (e) {}
      }
    };

    pdp.querySelectorAll('.pdp__variant-radio').forEach((r) => r.addEventListener('change', () => sync(true)));

    pdp.querySelectorAll('[data-pdp-qty-dec]').forEach((b) =>
      b.addEventListener('click', () => {
        if (qtyInput) qtyInput.value = Math.max(1, qty() - 1);
        sync();
      })
    );
    pdp.querySelectorAll('[data-pdp-qty-inc]').forEach((b) =>
      b.addEventListener('click', () => {
        if (qtyInput) qtyInput.value = qty() + 1;
        sync();
      })
    );
    if (qtyInput) qtyInput.addEventListener('input', () => sync());

    pdp.querySelectorAll('[data-pdp-tab]').forEach((tab) => {
      tab.addEventListener('click', () => {
        const value = tab.dataset.pdpTab;
        pdp.querySelectorAll('[data-pdp-tab]').forEach((t) => t.classList.toggle('is-active', t === tab));
        document.dispatchEvent(new CustomEvent('pdp:tab-change', { detail: { tab: value } }));
        filterThumbs(value);
        let firstVisible = null;
        variants.forEach((row) => {
          const match = row.dataset.tab === value;
          row.hidden = !match;
          if (match && !firstVisible) firstVisible = row;
        });
        if (firstVisible) {
          const radio = firstVisible.querySelector('.pdp__variant-radio');
          if (radio && !radio.disabled) {
            radio.checked = true;
            sync(true);
          }
        }
        if ((!firstVisible || !firstVisible.dataset.mediaId) && tab.dataset.mediaId) {
          showSlide(tab.dataset.mediaId);
        }
      });
    });

    pdp.querySelectorAll('[data-pdp-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => showSlide(thumb.dataset.mediaId));
    });

    const activeTabEl = pdp.querySelector('[data-pdp-tab].is-active');
    if (activeTabEl) filterThumbs(activeTabEl.dataset.pdpTab);

    sync();

    // Sold-out notify-me form: submit without a page reload, so it doesn't
    // trip the page's other customer form (e.g. the footer newsletter) into
    // also showing "subscribed" — Shopify's posted_successfully? is shared
    // by every customer form on the page.
    const soldoutForm = pdp.querySelector('.pdp__soldout-form');
    if (soldoutForm) {
      soldoutForm.addEventListener('submit', (e) => {
        e.preventDefault();
        const row = soldoutForm.querySelector('[data-pdp-soldout-row]');
        const success = soldoutForm.querySelector('[data-pdp-soldout-success]');
        const btn = soldoutForm.querySelector('[type="submit"]');
        if (btn) btn.disabled = true;

        fetch('/contact', { method: 'POST', body: new FormData(soldoutForm) })
          .then(() => {
            if (row) row.hidden = true;
            if (success) success.hidden = false;
          })
          .catch(() => {
            if (btn) btn.disabled = false;
          });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roll-on-bottle"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-rob]').forEach((rob) => {
    const photo = rob.querySelector('[data-rob-photo]');
    const video = rob.querySelector('[data-rob-video]');
    const vidEl = video ? video.querySelector('video') : null;

    rob.querySelectorAll('[data-rob-tab]').forEach((tab) => {
      tab.addEventListener('click', () => {
        const showVideo = tab.dataset.robTab === 'video';
        rob.querySelectorAll('[data-rob-tab]').forEach((t) => t.classList.toggle('is-active', t === tab));
        if (photo) photo.hidden = showVideo;
        if (video) video.hidden = !showVideo;
        if (vidEl) {
          if (showVideo) {
            const p = vidEl.play();
            if (p && p.catch) p.catch(() => {});
          } else {
            vidEl.pause();
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
